// Copyright (c) 2017 Comsearch, Inc., All rights reserved

const getBWandTxPowerMax = r => (
  r.reduce((a, d, i) => {
    // same check, different keys
    ['bandwidth', 'txPowerMax'].map(k => {
      if (a[k] === undefined || a[k] < d[k]) {
        a[k] = d[k]
      }
    })
    return a
  }, {})
)

export default getBWandTxPowerMax
